module.exports = __webpack_public_path__ + "file/Charte_COS_Grand_Est_V1_R001.asset.e2a811da.pdf";